import React from 'react';
import { SettingsMenu } from '../../settings/SettingsMenu';
const Settings = props => (React.createElement(SettingsMenu, Object.assign({ invalidate: () => { } }, props, { inSession: true })));
export default Settings;
